import { useEffect, useState } from "react";
import {
  GUARDIANES_DISCOVERED_EVENT,
  hasGuardianesBeenDiscovered,
} from "../guardianes/guardianesStorage";

export function useGuardianesDiscovery(): boolean {
  const [discovered, setDiscovered] = useState(hasGuardianesBeenDiscovered);

  useEffect(() => {
    const refresh = () => setDiscovered(hasGuardianesBeenDiscovered());
    window.addEventListener(GUARDIANES_DISCOVERED_EVENT, refresh);
    window.addEventListener("storage", refresh);
    return () => {
      window.removeEventListener(GUARDIANES_DISCOVERED_EVENT, refresh);
      window.removeEventListener("storage", refresh);
    };
  }, []);

  return discovered;
}
